// removed by extract-text-webpack-plugin
module.exports = {"api-details-section":"src-components----APIDetailsSection-module---api-details-section---2-bDl","text-container":"src-components----APIDetailsSection-module---text-container---2aai-","message":"src-components----APIDetailsSection-module---message---17-I0","splash-image-container":"src-components----APIDetailsSection-module---splash-image-container---378mC","splash-image":"src-components----APIDetailsSection-module---splash-image---2eLjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/APIDetailsSection.module.scss
// module id = 649
// module chunks = 115898287384546